import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { AbstractControl, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { apes } from 'src/app/datas/ape';
import { CompanyService } from 'src/app/services/company.service';
import { environment } from 'src/environments/environment';
import { CanvasCustomComponent } from '../canvas-custom/canvas-custom.component';
import { DateTime } from 'luxon';
import { Router } from '@angular/router';
import { FeeService } from '../../services/fee.service';
import { legalForms } from '../../datas/legal';

@Component({
  selector: 'app-register-company',
  templateUrl: './register-company.component.html',
  styleUrls: ['./register-company.component.scss'],
})
export class RegisterCompanyComponent implements OnInit {
  @ViewChild('signatureCanvas') signatureCanvas!: CanvasCustomComponent;
  paymentInputs: { key: string, value: string }[] = [];
  debug = false;

  registerCompagnyInformationForm!: FormGroup;
  registerCompagnyOurContactsForm!: FormGroup;
  registerCompagnyAuthorizeMyImageForm!: FormGroup;
  registerCompagnyCotisationForm!: FormGroup;

  readonly legalForms = legalForms;

  contacts: {
    id: number;
    lastName?: string;
    firstName?: string;
    job?: string;
    phone?: string;
    receiveCommunicationsByEMail_ocf?: string;
    receiveCommunicationsByWhatsApp_ocf?: string;
  }[] = [];

  showNumberUrsaf: boolean = false;

  // For cotisations
  showPartOnlineCreditCard: boolean = true;
  showPartOnsiteCreditCard: boolean = false;
  showPartChequePayable: boolean = false;
  showPartBankTransfer: boolean = false;
  showNbrInstalments: boolean = false;

  year!: number;

  // for canvas
  action!: string;

  //modal
  @ViewChild('modal', {static: true}) modal!: NgbModalRef;
  @ViewChild('modalInvoice', {static: true}) modalInvoice!: NgbModalRef;
  @ViewChild('paymentModal', {static: true}) paymentModal!: NgbModalRef;

  @ViewChild('form_1', {static: true}) form_1!: ElementRef;
  @ViewChild('form_2', {static: true}) form_2!: ElementRef;
  @ViewChild('form_3', {static: true}) form_3!: ElementRef;

  @ViewChild('form_1_btns', {static: true}) form_1_btns!: ElementRef;
  @ViewChild('form_2_btns', {static: true}) form_2_btns!: ElementRef;
  @ViewChild('form_3_btns', {static: true}) form_3_btns!: ElementRef;

  @ViewChild('form_1_progressbar', {static: true})
  form_1_progressbar!: ElementRef;
  @ViewChild('form_2_progressbar', {static: true})
  form_2_progressbar!: ElementRef;
  @ViewChild('form_3_progressbar', {static: true})
  form_3_progressbar!: ElementRef;

  modeViewModal: 'create' | 'duplicate' | 'edit' = 'create';

  // signature
  imageSignature!: string;

  //cotisation fn(effectif)
  cotisationData: { minRange: number; maxRange: number; amount: number }[] = [
    {minRange: 0, maxRange: 2, amount: 320},
    {minRange: 3, maxRange: 6, amount: 650},
    {minRange: 7, maxRange: 10, amount: 1030},
    {minRange: 11, maxRange: 15, amount: 1350},
    {minRange: 16, maxRange: 19, amount: 1700},
    {minRange: 20, maxRange: 25, amount: 2400},
    {minRange: 26, maxRange: 29, amount: 2850},
    {minRange: 30, maxRange: 39, amount: 3100},
    {minRange: 40, maxRange: 49, amount: 3500},
    {minRange: 50, maxRange: 59, amount: 4000},
    {minRange: 60, maxRange: 79, amount: 4600},
    {minRange: 80, maxRange: 99, amount: 5550},
    {minRange: 100, maxRange: 250, amount: 7500},
    {minRange: 251, maxRange: Number.POSITIVE_INFINITY, amount: 9500},
  ];

  // id invoice
  invoice_id!: number;

  listeApes = apes;
  fees: number = 0;

  isRenewal = false;

  constructor(
    private fb: FormBuilder,
    private modalService: NgbModal,
    private companyService: CompanyService,
    private router: Router,
    private feeService: FeeService,
  ) {
    window.scrollTo(0, 0);
    this.feeService.getFees('company', this.isRenewal, 0).subscribe(fees => this.fees = fees.fees);
  }

  ngOnInit(): void {
    let now = DateTime.now();
    if (now.month >= 12) {
      now = now.plus({year: 1});
    }
    this.year = now.year;
    this.init();

    const selectLegalForm = document.getElementById('legalForm');
    selectLegalForm?.addEventListener('click', () => {
      this.registerCompagnyInformationForm.get('legalForm')?.markAllAsTouched;
      this.registerCompagnyInformationForm
        .get('legalForm')
        ?.updateValueAndValidity();
    });

    // Ape code
  }

  init = () => {
    this.registerCompagnyInformationForm = this.fb.group({
      subscription: 'newSubscribtion',
      lastName: [null, Validators.required],
      firstName: [null, Validators.required],
      birthdate: [null, Validators.required],
      companyName: ['', Validators.required],
      tradeName: ['', Validators.required],
      address: ['', Validators.required],
      addressComplement: '',
      postalCode: ['', Validators.required],
      city: ['', Validators.required],
      job: ['', Validators.required],
      siretNumber: ['', this.validatorSiretNumber],
      apeCode: '',
      professionalActivity: [null, Validators.required],
      legalForm: [null, Validators.required],
      fixePhone: ['', this.validatorPhoneFrNumber],
      mobilePhone: ['', [this.validatorPhoneFrNumber, Validators.required]],
      email: ['', [Validators.required, Validators.email]],
      isSelfEmployed: 'none',
      numberURSAFF: [''],
      receiveCommunicationsByEMail: 'email',
      receiveCommunicationsByWhatsApp: 'whatsApp',
    });

    this.registerCompagnyOurContactsForm = this.fb.group({
      id: null,
      lastName: ['', Validators.required],
      firstName: ['', Validators.required],
      phone: ['', [this.validatorPhoneFrNumber, Validators.required]],
      job: ['', Validators.required],
      receiveCommunicationsByEMail_ocf: 'email',
      receiveCommunicationsByWhatsApp_ocf: 'none',
    });

    this.registerCompagnyAuthorizeMyImageForm = this.fb.group({
      authorizeMyImage: [false],
    });

    this.registerCompagnyCotisationForm = this.fb.group({
      headcount: [1, Validators.required],
      terme: 'onlineCreditCard',
      paymentInInstalments: [false],
      location: ['', Validators.required],
      datePayment: ['', Validators.required],
      /* onlineCreditCardField: [''], */
      checkNumber: null,
      transferNumber: null,
      nbrInstalments: [],
      signature: [null, Validators.required],
    });

    this.registerCompagnyInformationForm.get('subscription')?.valueChanges
      .subscribe(res => {
        this.isRenewal = res === 'renewal';
        this.registerCompagnyCotisationForm.patchValue({headCount: 0});
        this.feeService.getFees('company', this.isRenewal, this.registerCompagnyCotisationForm.value.headCount ?? 1)
          .subscribe(fees => this.fees = fees.fees);
      });
  };

  saveData = () => {
  };

  validatorSiretNumber = (
    c: AbstractControl,
  ): { [key: string]: boolean } | null => {
    const regex = new RegExp(/\d{14}/g);
    if (!regex.test(c.value)) {
      return {errorSiretNumber: true};
    }
    return null;
  };

  validatorPhoneFrNumber = (c: AbstractControl): { [key: string]: boolean } | null => {
    if (c.value === '') {
      return null;
    }

    const regex = new RegExp(
      /^(?:(?:(?:\+|00)33[ ]?(?:\(0\)[ ]?)?)|0){1}[1-9]{1}([ .-]?)(?:\d{2}\1?){3}\d{2}$/gm,
    );
    if (!regex.test(c.value)) {
      return {errorPhoneFrNumber: true};
    }
    return null;
  };

  validatorEmail = (c: AbstractControl): { [key: string]: boolean } | null => {
    const regex = new RegExp(
      /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/,
    );
    if (!regex.test(c.value)) {
      return {errorEmail: true};
    }
    return null;
  };

  handleSelfEmployed = (typeEmployed: string) => {
    const numberURSAFFControl =
      this.registerCompagnyInformationForm.get('numberURSAFF');

    if (typeEmployed === 'none') {
      this.showNumberUrsaf = false;
      numberURSAFFControl?.clearValidators();
      numberURSAFFControl?.setValue('');
    }
    if (typeEmployed === 'selfEmployed') {
      this.showNumberUrsaf = true;
      numberURSAFFControl?.setValidators(this.validatorSiretNumber);
    }
  };

  // Modal
  open(withResetForm = false) {
    if (withResetForm) {
      this.registerCompagnyOurContactsForm.reset({
        lastName: [],
        firstName: [],
        phone: [],
        job: [],
        receiveCommunicationsByEMail_ocf: 'email',
        receiveCommunicationsByWhatsApp_ocf: 'none',
      });
    }
    this.modalService.open(this.modal, {centered: true});
  }

  create = () => {
    const newContact = this.registerCompagnyOurContactsForm.value;
    newContact.id = Date.now();
    this.contacts.push(newContact);
    this.closeModal();
  };

  edit = () => {
    // let newContacts:[]| null = [];
    const newContact = this.registerCompagnyOurContactsForm.value;
    if (newContact) {
      let indexToUpdate = this.contacts.findIndex(
        (contact) => contact.id == newContact.id,
      );
      this.contacts[indexToUpdate] = newContact;
    }
    this.closeModal();
  };

  openModal = (id: number | null, mode: 'create' | 'duplicate' | 'edit') => {
    let contact;
    if (id) {
      contact = this.contacts.find((c: any) => {
        return c.id === id;
      });
    }

    switch (mode) {
      case 'create':
        this.registerCompagnyOurContactsForm.reset({
          lastName: [],
          firstName: [],
          phone: [],
          job: [],
          receiveCommunicationsByEMail_ocf: 'email',
          receiveCommunicationsByWhatsApp_ocf: 'none',
        });

        this.modeViewModal = 'create';
        break;

      case 'duplicate':
        if (contact) {
          this.registerCompagnyOurContactsForm.patchValue({
            id: Date.now(),
            lastName: contact.lastName,
            firstName: contact.firstName,
            phone: contact.phone,
            job: contact.job,
            receiveCommunicationsByEMail_ocf:
            contact.receiveCommunicationsByEMail_ocf,
            receiveCommunicationsByWhatsApp_ocf:
            contact.receiveCommunicationsByWhatsApp_ocf,
          });
          this.modeViewModal = 'duplicate';
        }
        break;

      case 'edit':
        if (contact) {
          this.registerCompagnyOurContactsForm.patchValue({
            id: contact.id,
            lastName: contact.lastName,
            firstName: contact.firstName,
            phone: contact.phone,
            job: contact.job,
            receiveCommunicationsByEMail_ocf:
            contact.receiveCommunicationsByEMail_ocf,
            receiveCommunicationsByWhatsApp_ocf:
            contact.receiveCommunicationsByWhatsApp_ocf,
          });
          this.modeViewModal = 'edit';
        }
        break;
    }

    this.modalService.open(this.modal, {centered: true});
  };

  closeModal = () => {
    const button = document.querySelector('.btn-close') as HTMLButtonElement;
    button?.click();
  };

  deleteContact = (idContactDelete: number) => {
    const newContacts = this.contacts.filter((c) => {
      return c.id !== idContactDelete;
    });
    this.contacts = newContacts;
  };

  handleSetTerme = (term: string) => {
    this.showPartOnlineCreditCard = false;
    this.showPartOnsiteCreditCard = false;
    this.showPartChequePayable = false;
    this.showPartBankTransfer = false;
    const checkNumberControl =
      this.registerCompagnyCotisationForm.get('checkNumber');
    const transferNumberControl =
      this.registerCompagnyCotisationForm.get('transferNumber');

    switch (term) {
      case 'onlineCreditCard':
        this.showPartOnlineCreditCard = true;
        checkNumberControl?.clearValidators();
        checkNumberControl?.setValue(null);
        transferNumberControl?.clearValidators();
        transferNumberControl?.setValue(null);
        break;

      case 'onsiteCreditCard':
        this.showPartOnsiteCreditCard = true;
        checkNumberControl?.clearValidators();
        checkNumberControl?.setValue(null);
        transferNumberControl?.clearValidators();
        transferNumberControl?.setValue(null);
        break;

      case 'chequePayable':
        this.showPartChequePayable = true;
        transferNumberControl?.clearValidators();
        transferNumberControl?.setValue(null);
        break;

      case 'bankTransfer':
        this.showPartBankTransfer = true;
        checkNumberControl?.clearValidators();
        checkNumberControl?.setValue(null);
        break;
    }
  };

  handleBtn1Next = () => {
    this.form_1.nativeElement.style.display = 'none';
    this.form_2.nativeElement.style.display = 'block';

    this.form_1_btns.nativeElement.style.display = 'none';
    this.form_2_btns.nativeElement.style.display = 'flex';
    this.form_2_progressbar.nativeElement.classList.add('active');
    window.scrollTo(0, 0);
  };

  handleBtn2Back = () => {
    this.form_1.nativeElement.style.display = 'block';
    this.form_2.nativeElement.style.display = 'none';

    this.form_1_btns.nativeElement.style.display = 'flex';
    this.form_2_btns.nativeElement.style.display = 'none';
    this.form_2_progressbar.nativeElement.classList.remove('active');
    window.scrollTo(0, 0);
  };

  handleBtn2Next = () => {
    this.form_2.nativeElement.style.display = 'none';
    this.form_3.nativeElement.style.display = 'block';

    this.form_2_btns.nativeElement.style.display = 'none';
    this.form_3_btns.nativeElement.style.display = 'flex';
    this.form_3_progressbar.nativeElement.classList.add('active');
    window.scrollTo(0, 0);
  };

  handleBtn3Back = () => {
    this.form_2.nativeElement.style.display = 'block';
    this.form_3.nativeElement.style.display = 'none';

    this.form_2_btns.nativeElement.style.display = 'flex';
    this.form_3_btns.nativeElement.style.display = 'none';

    this.form_3_progressbar.nativeElement.classList.remove('active');
    window.scrollTo(0, 0);
  };

  handleClear = () => {
    this.action = 'clear';
  };

  send = () => {
    this.signatureCanvas.handleValidate();
    const formData = new FormData();

    // Informations
    const dataInfo = this.registerCompagnyInformationForm.value;
    for (key in dataInfo) {
      formData.append(key, dataInfo[key]);
    }

    const imageInfo = this.registerCompagnyAuthorizeMyImageForm.value;
    for (key in imageInfo) {
      formData.append(key, imageInfo[key]);
    }

    // Signature
    if (this.imageSignature) {
      formData.append('signature', this.imageSignature);
    }

    // Our Contacts
    formData.append('contacts', JSON.stringify(this.contacts));

    // Cotisation
    const dataCotisation = this.registerCompagnyCotisationForm.value;
    for (var key in dataCotisation) {
      formData.append(key, dataCotisation[key]);
    }

    this.companyService.send(formData).subscribe((resp: any) => {
      if (resp) {
        const id = resp.registration.id;

        if (this.registerCompagnyCotisationForm.value.terme !== 'onlineCreditCard') {
          this.router.navigate(['/recapitulatif'])
        } else {
          this.companyService.getPaymentInputs(id).subscribe(res => {
            for (const [key, value] of Object.entries(res)) {
              this.paymentInputs.push({key: key, value: value});
            }
            this.modalService.open(this.paymentModal);
          });
        }
      }
    });
  };

  handleExportImage = (image: string) => {
    this.imageSignature = image;
  };

  handleFill = () => {
    this.registerCompagnyInformationForm.patchValue({
      subscription: 'newSubscribtion',
      lastName: 'Company',
      firstName: 'John',
      birthdate: '1980-08-06',
      // undersignedLastName: 'john doe',
      // undersignedBirthdate: '2023-03-07',
      companyName: 'ma petite entreprise',
      tradeName: 'My Little Company',
      address: '1 rue de la victoire',
      addressComplement: '',
      postalCode: '75000',
      city: 'Paris',
      job: 'président',
      siretNumber: '0102034050607809',
      apeCode: '',
      professionalActivity: '6201Z',
      legalForm: 2,
      fixePhone: '0102030405',
      mobilePhone: '0601020304',
      email: 'john@usts.fr',
      isSelfEmployed: 'none',
      numberURSAFF: '',
      receiveCommunicationsByEMail: 'email',
      receiveCommunicationsByWhatsApp: 'whatsApp',
    });

    this.registerCompagnyCotisationForm.patchValue({
      location: 'Paris',
      datePayment: (new Date()).toISOString().split('T')[0],
    })
  };

  choicePaymentInInstalments = (event: any) => {
    const nbrInstalments =
      this.registerCompagnyCotisationForm.get('nbrInstalments');

    if (event.target.checked) {
      this.showNbrInstalments = true;
    } else {
      this.showNbrInstalments = false;
      nbrInstalments?.clearValidators();
      nbrInstalments?.setValue(null);
    }
  };

  checkIfNumber = (str: string) => {
    var n = Math.floor(Number(str));
    return n !== Infinity && String(n) === str && n >= 0;
  };

  //gets
  get lastName() {
    return this.registerCompagnyInformationForm.controls['lastName'];
  }

  get firstName() {
    return this.registerCompagnyInformationForm.controls['firstName'];
  }

  get email() {
    return this.registerCompagnyInformationForm.controls['email'];
  }

  get companyName() {
    return this.registerCompagnyInformationForm.controls['companyName'];
  }

  get address() {
    return this.registerCompagnyInformationForm.controls['address'];
  }

  get postalCode() {
    return this.registerCompagnyInformationForm.controls['postalCode'];
  }

  get city() {
    return this.registerCompagnyInformationForm.controls['city'];
  }

  get siretNumber() {
    return this.registerCompagnyInformationForm.controls['siretNumber'];
  }

  get fixePhone() {
    return this.registerCompagnyInformationForm.controls['fixePhone'];
  }

  get mobilePhone() {
    return this.registerCompagnyInformationForm.controls['mobilePhone'];
  }


  getFullName(): string {
    return `${this.registerCompagnyInformationForm.value.firstName ?? '___'} ${this.registerCompagnyInformationForm.value.lastName ?? '___'}`
  }

  getBirthDate(): string {
    if (this.registerCompagnyInformationForm.value.birthdate) {
      let date: DateTime = DateTime.fromFormat(this.registerCompagnyInformationForm.value.birthdate, 'yyyy-MM-dd');
      date = date.setLocale('fr')

      return date.toLocaleString(DateTime.DATE_SHORT);
    }
    return '___';
  }

  calculateFees($event: any) {
    const headCount = $event.target.valueAsNumber;
    this.feeService.getFees('company', this.isRenewal, headCount).subscribe(fees => this.fees = fees.fees);
  }
}
